import { Mapper } from './base-mapper';
import type { Method } from '@/types/Method';
import type { GetMethodListResponseDTO } from '@/core/dto/method';

export class MethodFindAllMapper extends Mapper<Method> {
	private readonly methods: GetMethodListResponseDTO;

	constructor(methods: GetMethodListResponseDTO) {
		super();
		this.methods = methods;
	}

	toTransform(method: GetMethodListResponseDTO['rows'][0]): Method {
		return {
			id: method.id,
			name: method.name,
			description: method.description,
			is_public: Boolean(method.is_public)
		};
	}

	toDomain(): Method[] {
		return (this.methods?.rows ?? []).map(this.toTransform.bind(this));
	}
}
